const root = document.querySelector('[data-safestep-cro]');

if (root && !document.documentElement.dataset.safestepCroReady) {
  document.documentElement.dataset.safestepCroReady = 'true';

  const main = root.closest('main') || document.querySelector('main');
  if (main) main.dataset.template = 'product.safestep-cro';

  const reviews = document.querySelector('[id$="__17685824425ee60c69"]');
  const recommendations = document.querySelector('[id$="__product_recommendations_qggXJq"]');
  if (reviews && recommendations && reviews.parentNode === recommendations.parentNode) {
    recommendations.parentNode.insertBefore(reviews, recommendations);
  }

  const track = (eventName) => {
    if (typeof window.clarity === 'function') window.clarity('event', eventName);
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest('variant-picker input[type="radio"]');
    if (!input) return;

    const optionName = (input.dataset.optionName || '').toLowerCase();
    if (!optionName.includes('size') && !optionName.includes('women') && !optionName.includes('men')) return;

    document.querySelectorAll('[data-pdp-selected-size]').forEach((node) => {
      node.textContent = input.value;
    });
    track('size_selected');
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('button[name="add"]');
    if (!button || button.disabled) return;

    track(button.closest('sticky-add-to-cart') ? 'add_to_cart_sticky' : 'add_to_cart_main');
  });
}
